import { Message, MessageBox } from "element-ui";
import request from "./request";

export default {
  showMsg(message, type, duration) {
    Message({
      message,
      type,
      showClose: true,
      duration: duration || 3000,
    });
  },
  showMsgBox(msg, title, type) {
    return new Promise((resolve, reject) => {
      MessageBox.confirm(msg || "确定进行删除操作？", title || "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type || "warning",
        customClass: "round-msg-box",
      })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject("取消操作");
        });
    });
  },
  showMsgAlert(msg, title) {
    return new Promise((resolve) => {
      MessageBox.alert(msg || "这是一段内容", title || "标题名称", {
        confirmButtonText: "确定",
        customClass: "round-msg-box",
        callback: (action) => {
          resolve(action);
        },
      });
    });
  },
  list(moduleUrl, query) {
    if (query && query.total != undefined) query.total = undefined;
    return request({
      url: moduleUrl,
      method: "get",
      params: query,
    });
  },
  create(moduleUrl, data, headers) {
    return request({
      url: moduleUrl + "/create",
      method: "post",
      data,
      headers,
    });
  },
  /**编辑保存 */
  update(moduleUrl, data, headers) {
    return request({
      url: moduleUrl + "/update",
      method: "post",
      data,
      headers,
    });
  },
  /**状态启停 */
  updateStatus(url) {
    return request({
      url: url,
      method: "post",
    });
  },
  /**获取详情 */
  detail(moduleUrl, uuid) {
    return request({
      url: moduleUrl + "/detail" + (uuid ? `/${uuid}` : ""),
      method: "get",
    });
  },
  /**删除 */
  remove(moduleUrl, uuIds) {
    return request({
      url: moduleUrl,
      method: "post",
      data: uuIds,
    });
  },
};
